const e = ["", "default", "small", "large"];
export {
  e as componentSizes
};
